<div class="flex flex-col bg-white p-4 h-full overflow-auto">
  <a [routerLink]="['/']">
    <span class="sr-only">B&T Logo</span>
    <img class="h-16 w-auto" src="/assets/images/logo_black.svg" alt="" />
  </a>
  <div class="flex flex-col space-y-2 mt-6">
    @for (item of nav.getMenuItems(); track $index) {
      <a
        class="flex items-center text-sm text-gray-700 hover:text-gray-800 border-b pb-2 pl-2 cursor-pointer"
        [class.font-bold]="nav.isRouteActive(item.routerLink)"
        [class.font-medium]="!nav.isRouteActive(item.routerLink)"
        (click)="route(item.routerLink)"
        >{{ item.text | i18n }}</a
      >
      @if (nav.getChildItems(item.routerLink); as children) {
        @if (children.length > 0) {
          @for (child of children; track $index) {
            <a
              class="pl-4 flex items-center text-sm text-gray-700 hover:text-gray-800 border-b pb-2 cursor-pointer"
              [class.font-bold]="nav.isChildRouteActive(child.routerLink)"
              [class.font-medium]="!nav.isChildRouteActive(child.routerLink)"
              (click)="route(child.routerLink)"
              >{{ child.text | i18n }}</a
            >
          }
        }
      }
    }
  </div>
</div>
